import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

import { useForm } from "react-hook-form";

import { login } from "../app/actions/auth";

import Input from "./Form/Input";
import SubmitButton from "./Form/SubmitButton";

const Login = (props) => {
  let navigate = useNavigate();

  const { isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    // console.log("onSubmit");
    setLoading(true);
    // console.log(data);
    const { username, password } = data;

    dispatch(login(username, password))
      .then(() => {
        navigate("/dashboard");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  if (isLoggedIn) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Input
          label="Username"
          name="username"
          type="text"
          register={register}
          options={{ required: true }}
        />
        {errors.username && <span>This field is required</span>}
      </div>
      <div>
        <Input
          label="Password"
          name="password"
          type="password"
          register={register}
          options={{ required: true }}
        />
        {errors.password && <span>This field is required</span>}
      </div>

      <SubmitButton loading={loading} />
    </form>
  );
};

export default Login;
